import React from "react";

// Classname joiner
const cn = (...classes) => {
  return classes.filter(Boolean).join(" ");
};

// Define default and domain-specific classes
const defaultCardClass =
  "bg-[#F8F8F8] rounded-20 lg:px-[32px] lg:py-[30px] p-[25px] lg:mx-[25px] mx-[15px] max-w-[491px] w-full !mx-auto";


// Card component
const Card = ({ className, ...props }) => {
  return (
    <div
      data-slot="card"
      className={cn(defaultCardClass, className)}
      {...props}
    />
  );
};

export { Card };
